import type { ComponentType } from 'react';
import type { PublicRoute } from '../../lib/route';
import TimeDistanceDiagramPage from './TimeDistanceDiagramPage';
import GreenWaveOffsetPage from './GreenWaveOffsetPage';
import WorkedExamplePage from './WorkedExamplePage';
import SynchroUtdfImportPage from './SynchroUtdfImportPage';

/** Learn page component per route path (framing V9/V10) */
export const LEARN_PAGE_BY_PATH: Record<string, ComponentType<{ route: PublicRoute }>> = {
  '/learn/time-distance-diagram': TimeDistanceDiagramPage,
  '/learn/green-wave-offset': GreenWaveOffsetPage,
  '/learn/worked-example-corridor': WorkedExamplePage,
  '/learn/synchro-utdf-import': SynchroUtdfImportPage,
};
